import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const StatBlockGridStyled = styled(Box).attrs({
  mr: { sm: '200' },
  flexDirection: { sm: 'column' },
  px: { sm: '500' },
  pt: { sm: '400' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    flex: 1.5;
  `}
`;
